import { render, staticRenderFns } from "./VesselTrackingNavbar.vue?vue&type=template&id=45bdbdd9&scoped=true"
import script from "./VesselTrackingNavbar.vue?vue&type=script&lang=js"
export * from "./VesselTrackingNavbar.vue?vue&type=script&lang=js"
import style0 from "./VesselTrackingNavbar.vue?vue&type=style&index=0&id=45bdbdd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdbdd9",
  null
  
)

export default component.exports